import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { usePriceComparison } from "@/contexts/classified";
import { Box } from "@gemini/core";
import { CaretDownFilledIcon } from "@gemini/icons";
import { useContext, useEffect, useRef, useState } from "react";
import { useI18n } from "@/contexts/i18n";
import { SliderRefContext } from "./PriceComparisonSlider";
export const PriceComparisonSliderMarker = ({ pricePerSqm, }) => {
    var _a;
    const { t } = useI18n();
    const [markerPosition, setMarkerPosition] = useState(0);
    const markerInPercent = (_a = usePriceComparison()) === null || _a === void 0 ? void 0 : _a.markerPosition;
    const markerRef = useRef(null);
    const sliderRef = useContext(SliderRefContext);
    useEffect(() => {
        const handleResize = () => {
            var _a, _b;
            const markerWidth = ((_a = markerRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) * (markerInPercent / 100);
            const sliderWidth = ((_b = sliderRef.current) === null || _b === void 0 ? void 0 : _b.offsetWidth) * (markerInPercent / 100);
            setMarkerPosition(sliderWidth - markerWidth);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [sliderRef, markerInPercent]);
    if (typeof markerInPercent === "undefined")
        return null;
    return (_jsxs(Box, { ref: markerRef, left: markerPosition, backgroundColor: "color.surface.constant.black.default", display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "center", borderRadius: "radius.8", width: "max-content", position: "relative", marginBottom: "spacing.16", padding: "spacing.12", children: [_jsx(Box, { color: "color.background.constant.white", typography: "typography.body.14.regular", children: t("pricecomparison.this_listing") }), _jsx(Box, { color: "color.background.constant.white", typography: "typography.body.16.bold", children: `${pricePerSqm} €/m²` }), _jsx(Box, { position: "absolute", bottom: "-spacing.12", left: markerInPercent >= markerPosition ? "0" : `calc(100% - 24px)`, children: _jsx(CaretDownFilledIcon, { size: "sizing.24" }) })] }));
};
